import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_2 = { class: "chevron-cell" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = {
  key: 1,
  class: "table-peeking",
  colspan: "100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { colspan: "100" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Show me more", -1)


import PeekFields from "./PeekFields.vue";

const __default__ = {
  components: { PeekFields },
};
import { UsePerformanceTable } from "./Hooks/UsePerformanceTable";
import { UsePerformanceTableDetails } from "./Hooks/UsePerformanceTableDetails";
import { UsePerformancePeekTaxonomy } from "./Hooks/UsePerformancePeekTaxonomy";
import { UseMainStore } from "../../State/SingleViewStorePinia";
import { storeToRefs } from "pinia";
import { watch, computed, onBeforeMount, onMounted, ref, nextTick, toRef } from "vue";
import { UseStringHelper } from "../../../Helper/Functional/UseStringHelper";
import {
  TAllTableHeaderValues,
  TAllTableHeaders,
} from "../../../../typings/DataFetching";
import { IDetailTreeSingle } from "../../../../typings/TableTypes";
import { UseProgramStore } from "../../State/Stores/ProgramStore";
import {
  performanceLoadAsyncData,
  performanceLoadComparisonData,
} from "../../../../generics/generics";
import { UseDateStore } from "../../State/Stores/DateStore";
import { UseAxiosErrorHelper } from "../../../Helper/ThirdParty/UseAxiosErrorHelper";
import { UseComparisonHelper } from "../../../Helper/Stateful/UseComparisonHelper";
import { UseReportSettingsStore } from "../../State/Stores/ReportSettingsStore";
import { PerformanceTableAndChartData } from "../../../Helper/Stateful/PerformanceTableAndChartData";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    topTaxonomy: null,
    index: null,
    row: null,
    tree: null
  },
  setup(__props: any) {

const props = __props as {
  topTaxonomy: number;
  index: number;
  row: TAllTableHeaderValues<TAllTableHeaders>;
  tree: IDetailTreeSingle;
}

UseAxiosErrorHelper();

const { columns } = UsePerformanceTable();

const { setOpenedDetails } = UsePerformanceTableDetails();

const { init, comparisonDates, comparing } = UseComparisonHelper();

const {
  getPerformanceTableSortDirection: sortOrder,
  getPerformanceTableSortMetric: sortField,
} = storeToRefs(UseReportSettingsStore());

const { tableLoading: loading } = PerformanceTableAndChartData();

const {
  peekFourData: data,
  peekFourHeaders: headers,
  peekFourComparisonData: comparisonData,
  peekFourTaxonomy: taxonomy,
  sortedDataHook,
  chunkedDataHook,
} = UsePerformancePeekTaxonomy();

const { getApiBaseUrl } = storeToRefs(UseMainStore());
const { getCurrentProgram } = storeToRefs(UseProgramStore());
const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());

const { validateInternalParameter, validateApiParameter } = UseStringHelper();



const getTaxonomyOne = computed(() =>
  validateApiParameter(props.row.taxonomy_1 as string)
);
const getTaxonomyTwo = computed(() =>
  validateApiParameter(props.row.taxonomy_2 as string)
);
const getTaxonomyThree = computed(() =>
  validateApiParameter(props.row.taxonomy_3 as string)
);

const sortedData = sortedDataHook(data, sortField, sortOrder);
const chunkedData = chunkedDataHook(sortedData);

const url = ref(
  getApiBaseUrl.value +
    "/programs/" +
    getCurrentProgram.value +
    "/performance/table/single/taxonomy_1/" +
    getTaxonomyOne.value +
    "/taxonomy_2/" +
    getTaxonomyTwo.value +
    "/taxonomy_3/" +
    getTaxonomyThree.value +
    "/taxonomy_4" +
    "?date_from=" +
    getDateFrom.value +
    "&date_to=" +
    getDateTo.value
);
const comparisonUrl = computed(() => {
  return (
    getApiBaseUrl.value +
    "/programs/" +
    getCurrentProgram.value +
    "/performance/table/single/taxonomy_1/" +
    getTaxonomyOne.value +
    "/taxonomy_2/" +
    getTaxonomyTwo.value +
    "/taxonomy_3/" +
    getTaxonomyThree.value +
    "/taxonomy_4" +
    "?date_from=" +
    comparisonDates.value.start +
    "&date_to=" +
    comparisonDates.value.end
  );
});

const updateKey = ref(0);
//Before we mount
onBeforeMount(() => {
  taxonomy.value = getTaxonomyTwo.value;
});

//On mount
onMounted(() => {
  init();
  performanceLoadAsyncData(data, headers, toRef(props, "tree"))(url, loading);
  performanceLoadComparisonData(comparing, comparisonData)(
    comparisonUrl,
    loading,
    "taxonomy_3"
  );
});
//Set up watchers

watch(comparing, () => {
  performanceLoadComparisonData(comparing, comparisonData)(
    comparisonUrl,
    loading,
    "taxonomy_3"
  );
});
watch(comparisonUrl, () => {
  if (comparing.value) {
    performanceLoadComparisonData(comparing, comparisonData)(
      comparisonUrl,
      loading,
      "taxonomy_3"
    );
  }
});
watch(url, () => {
  performanceLoadAsyncData(data, headers, toRef(props, "tree"))(url, loading);
});
watch(data, () => {
  setOpenedDetails("taxonomy_3", data, toRef(props, "tree"));
});
watch(toRef(props, "index"), () => {
  nextTick(() => {
    updateKey.value = updateKey.value++;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    colspan: "100",
    style: {"display":"contents"},
    key: 'div' + _unref(getTaxonomyOne) + _unref(getTaxonomyTwo) + _unref(getTaxonomyThree) + __props.index
  }, [
    (_unref(chunkedData).length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(chunkedData)[0], (innerData) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: 
        'row' +
        _unref(getTaxonomyOne) +
        _unref(getTaxonomyTwo) +
        _unref(getTaxonomyThree) +
        innerData.taxonomy_4 +
        __props.index
      ,
            class: "table-peeking",
            colspan: "100"
          }, [
            _hoisted_1,
            _createElementVNode("td", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(4 - __props.topTaxonomy - 1, (index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  _hoisted_3
                ], 64))
              }), 256)),
              (__props.topTaxonomy !== 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(innerData.taxonomy_4), 1)
            ]),
            _createVNode(PeekFields, {
              row: innerData,
              columns: _unref(columns),
              comparing: _unref(comparing),
              "onUpdate:comparing": _cache[0] || (_cache[0] = ($event: any) => (_isRef(comparing) ? (comparing).value = $event : null)),
              "comparison-data": _unref(comparisonData),
              "onUpdate:comparison-data": _cache[1] || (_cache[1] = ($event: any) => (_isRef(comparisonData) ? (comparisonData).value = $event : null)),
              taxonomy: "taxonomy_4"
            }, null, 8, ["row", "columns", "comparing", "comparison-data"])
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (_unref(sortedData).length > 10)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("td", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(4 - __props.topTaxonomy - 1, (index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_8
              ], 64))
            }), 256)),
            (__props.topTaxonomy !== 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: `/performance/taxonomy_one/${_unref(validateInternalParameter)(__props.row.taxonomy_1 as string)}/taxonomy_two/${_unref(validateInternalParameter)(__props.row.taxonomy_2 as string)}/taxonomy_three/${_unref(validateInternalParameter)(__props.row.taxonomy_3 as string)}`
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})